import axios from 'axios';

const PREFIX = 'dirRef:';
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

export function rememberDirectoryVisit(laundryId, search) {
    if (!laundryId) return;
    try {
        if (new URLSearchParams(search || '').get('src') !== 'directory') return;
        localStorage.setItem(PREFIX + laundryId, String(Date.now()));
    } catch (e) {}
}

export function pendingDirectoryLaundries(now = Date.now()) {
    const ids = [];
    const expired = [];
    try {
        for (let i = 0; i < localStorage.length; i += 1) {
            const key = localStorage.key(i);
            if (!key || !key.startsWith(PREFIX)) continue;
            const at = Number(localStorage.getItem(key));
            if (at && now - at <= MAX_AGE_MS) ids.push(key.slice(PREFIX.length));
            else expired.push(key);
        }
        expired.forEach((key) => localStorage.removeItem(key));
    } catch (e) {}
    return ids;
}

export async function claimDirectoryReferrals(accessToken) {
    if (!accessToken) return;
    const apiUrl = process.env.REACT_APP_AWS_API_URL || '';
    for (const laundryId of pendingDirectoryLaundries()) {
        try {
            await axios.post(`${apiUrl}/api/directory/attribute`, { laundryId }, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            localStorage.removeItem(PREFIX + laundryId);
        } catch (e) {}
    }
}
